const api_url = function() {
  return process.env.NODE_ENV === 'production' ? 'https://nibi.com.co/api/business' : '/api/business';
}

const main_api_url = function() {
  return process.env.NODE_ENV === 'production' ? 'https://nibi.com.co' : '';
}

export const apiUrl = api_url();
export const mainApiUrl = main_api_url();
export const businessName = 'CEMEX';
export const businessUserType1 = 'CEMEX_1';
export const businessUserType2 = 'CEMEX_2';
